/** @jsxImportSource @emotion/react */

import tw from "twin.macro";

export const CardHeaderActions = tw.div`flex gap-2`;

export const CardHeader = tw.div`flex justify-between text-base font-medium`;

const Card = tw.div`rounded-lg bg-white  p-4 space-y-4`;

export default Card;
